import { default as MuiAccordionSummary, AccordionSummaryProps } from '@mui/material/AccordionSummary'
import * as React from 'react'

import { createStyles, WithStyles, withStyles } from '../../design-tokens/styles'
import { Theme } from '../../design-tokens/theme'
import Icon, { Icons } from '../Icon'

const useStyles = ({ layoutSpacing }: Theme) =>
  createStyles({
    root: {
      minHeight: 'auto',
      padding: layoutSpacing.none,
      '&$expanded': {
        minHeight: 'auto',
      },
    },
    content: {
      margin: layoutSpacing.none,
      '&$expanded': {
        margin: layoutSpacing.none,
      },
    },
    expanded: { minHeight: 'auto' },
  })

class AccordionSummary extends React.Component<AccordionSummaryProps & WithStyles<typeof useStyles>> {
  // We need to this in order for Accordion to render correctly this component as its child
  public static muiName = 'AccordionSummary'
  public render() {
    return <MuiAccordionSummary expandIcon={<Icon icon={Icons.EXPAND_MORE} size="x-large" />} {...this.props} />
  }
}

export default withStyles(useStyles)(AccordionSummary)
